import './styles/base.less';
import './styles/index.less';
import './styles/login.less';
import './styles/dashboard.less';
import './styles/trackedplayers.less';
import './styles/filterCounty.less';
import './styles/filterTables.less';
import './styles/editModal.less';
import './styles/settings.less';



// WEBPACK FOOTER //
// ./src/combinedStyles.js